import * as types from "../types/categorias_produtos";

const INITIAL_STATE = {
  filtro: {
    titulo: "",
  },
  page: 1,
  perpage: 10,
  total: 0,
  categorias: [],
  categoria: {},
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_PRODUTOS_CATEGORIA:
      return { ...state, categoria: action.payload };
    case types.LOAD_PRODUTOS_CATEGORIAS:
      return { ...state, categorias: action.payload };
    case types.SET_PAGE_PRODUTOS_CATEGORIA:
      return { ...state, page: action.payload };
    case types.SET_PERPAGE_PRODUTOS_CATEGORIA:
      return { ...state, perpage: action.payload };
    case types.SET_TOTAL_PRODUTOS_CATEGORIA:
      return { ...state, total: action.payload };
    case types.LOADING_PRODUTOS_CATEGORIA:
      return { ...state, loading: action.payload };
    case types.SET_FILTRO_PRODUTOS_CATEGORIA:
      return {
        ...state,
        filtro: { ...state.filtro, ...action.payload },
      };
    default:
      return state;
  }
};
